var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.value)?_c('strong',[_c('md-icon',{staticClass:"text-success"},[_vm._v("check")])],1):_vm._e(),(!_vm.value)?_c('strong',[_c('md-icon',{staticClass:"text-danger"},[_vm._v("error_outline")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }